import { useEffect } from 'react'
import { ChatSettingsSheet } from './components/chat-settings'
import ChatContainer from './components/chatbox-container'
import GalgameContainer from './components/galgame-container'
import { useEngine } from './hooks/use-engine'
import { useEnginePlayActions } from './hooks/use-engine-play-action'
import { useEngineStore } from './stores/use-engine-store'

type ChatProps = {
  sessionId: string
}

export const Chat = ({ sessionId }: ChatProps) => {
  const { mode, engine } = useEngineStore()
  const { isOpenBackgroundImg } = engine

  // 统一通过 sessionId 获取历史消息，不再根据 processMode 跳过
  const {
    serverMessages,
    initializeFromCache,
    sessionInfo,
    isPolling,
    resetPolling,
  } = useEnginePlayActions(sessionId)
  const clearMessages = useEngineStore((s) => s.messages.clearMessages)
  // 检查是否有待处理的轮询结果
  const pendingResult = useEngineStore((s) => s.choice.pendingResult)

  // 当 sessionId 变化时（切换会话），主动清理 Store 状态
  // 确保新进入的会话不会看到旧会话的消息或残留的"思考中"状态
  useEffect(() => {
    resetPolling()
    clearMessages()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]) // 仅监听 sessionId 变化

  // 从 session 信息中获取 engineId，使用 useEngine hook 获取完整的 engine 数据
  const engineId = sessionInfo?.engineId
  useEngine(engineId)

  // 直接在此处同步数据到 Store，避免依赖嵌套 Hook 中的闭包
  // 守护条件：
  // - !isPolling: 轮询进行中不同步（用户正在交互）
  // - !pendingResult: 有待处理结果时不同步（防止覆盖即将追加的消息）
  useEffect(() => {
    if (
      !isPolling &&
      !pendingResult &&
      serverMessages &&
      serverMessages.length > 0
    ) {
      initializeFromCache()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serverMessages?.length, sessionId, isPolling])

  return (
    <div className='chat flex h-full w-full'>
      {/* 背景层 */}
      <div
        className='bg-background absolute inset-0 bg-cover bg-center transition-opacity duration-700'
        style={{
          backgroundImage: `url(${engine.currentEngine?.backgroundImageUrl})`,
          opacity: isOpenBackgroundImg ? 1 : 0,
        }}
      />
      {mode.mode === 'chat' ? (
        <ChatContainer sessionId={sessionId} />
      ) : (
        <GalgameContainer sessionId={sessionId} />
      )}
      <ChatSettingsSheet />
    </div>
  )
}
